// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"cccb062b","621":"d5afce84","743":"a6ec5c85"}[chunkId] + ".chunk.js";
};